module.exports = `${require.publicPath}sby-logo-dark-sm.d8c32b2d.webp`;